import styled from "styled-components";

import { FlexDiv, FlexSection } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

export const StyledRightSection = styled(FlexSection)`
  flex: 1;
  max-width: 430px;
  flex-direction: column;

  @media only screen and (max-width: 600px) {
    padding: 24px 16px 0px 16px;
  }
`;

export const ConditionTextContainer = styled(FlexDiv)`
  padding: 24px 16px 24px 16px;
  @media only screen and (min-width: 601px) {
    display: none;
  }
`;

export const StyledConditionsLink = styled(Typography)`
  font-size: 14px;
  line-height: 24px;
  font-family: var(--man-500);
  color: ${theme.colorsV2.gray.shade_800};
  a {
    color: ${theme.colors.link_color};
  }
  @media only screen and (max-width: 600px) {
    letter-spacing: 0.4px;
    text-align: center;
  }
`;
